import React from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const PlanCardSkeleton: React.FC = () => (
  <Card className="h-full flex flex-col border shadow-sm w-64">
    <CardHeader className="text-center pt-6 pb-4">
      <div className="flex items-center justify-center space-x-2 mb-3">
        <Skeleton className="h-4 w-4 rounded-xs" />
        <Skeleton className="h-6 w-20" />
      </div>
      <div className="h-[120px] flex flex-col justify-center">
        <Skeleton className="h-8 w-32 mx-auto mb-2" />
        <Skeleton className="h-3 w-24 mx-auto" />
      </div>
    </CardHeader>
    <CardContent className="px-6 flex-1 pb-4">
      <div className="space-y-3">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="flex items-start space-x-3">
            <Skeleton className="h-4 w-4 rounded-xs flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <Skeleton className="h-3 w-20 mb-1" />
              <Skeleton className="h-3 w-14" />
            </div>
          </div>
        ))}
      </div>
    </CardContent>
    <CardFooter className="px-6 pb-6">
      <Skeleton className="w-full h-9" />
    </CardFooter>
  </Card>
);
